import { useEffect, useRef } from "react";
import { useFormContext } from "react-hook-form";
import { CreateConstructionSiteClientFormData } from "./useCreateConstructionSiteForm";
import { SelectedClient } from "../../../pages/constructionSites/projectForm/CommonProjectForm";

type UseClientAutoSelectionParams = {
	client: SelectedClient;
	setSelectedClient: (client: SelectedClient) => void;
	initialClientSocietyId: number | null;
};

export const useClientAutoSelection = ({
	client,
	setSelectedClient,
	initialClientSocietyId,
}: UseClientAutoSelectionParams) => {
	const { watch } = useFormContext<CreateConstructionSiteClientFormData>();
	const clientValue = watch("clientSociety");
	const clientSocietyIdValue = watch("clientSocietyId");

	const initialClientSocietyIdRef = useRef<number | null>(
		initialClientSocietyId,
	);
	const lastAutoSelectedSocietyIdRef = useRef<number | null>(null);

	useEffect(() => {
		const isFormReset =
			client === null &&
			(clientSocietyIdValue === undefined || clientSocietyIdValue === null);

		if (typeof initialClientSocietyId === "number") {
			initialClientSocietyIdRef.current = initialClientSocietyId;
			lastAutoSelectedSocietyIdRef.current = initialClientSocietyId;
		} else if (isFormReset) {
			initialClientSocietyIdRef.current = null;
			lastAutoSelectedSocietyIdRef.current = null;
		} else {
			initialClientSocietyIdRef.current = null;
		}

		if (
			client === null &&
			clientValue &&
			clientValue.id !== undefined &&
			typeof clientSocietyIdValue === "number" &&
			clientSocietyIdValue !== initialClientSocietyIdRef.current &&
			clientSocietyIdValue !== lastAutoSelectedSocietyIdRef.current
		) {
			setSelectedClient({
				...clientValue,
				id: clientValue.id,
				headOfficeAddress: {
					city: clientValue.city,
					postalCode: clientValue.postalCode,
					streetName: clientValue.streetName,
					streetNumber: clientValue.streetNumber ?? null,
				},
			});
			lastAutoSelectedSocietyIdRef.current = clientSocietyIdValue;
		}
	}, [
		client,
		clientValue,
		clientSocietyIdValue,
		initialClientSocietyId,
		setSelectedClient,
	]);
};
